import { useEffect, useState } from 'react'
import Box from '@mui/material/Box'
import { styled } from '@mui/material/styles'

import CloudflareImage from '@ecm/ui/element/CloudflareImage'
import { inputStyle, labelStyle } from '@ecm/ui/element/input/Shared'

export type SearchInputProps = {
  className?: string
  id: string
  label: string
  margin?: string
  onChange?: (val: string) => void
  onClear: () => void
  onSubmit: () => void
  placeholder?: string
  value?: string
}

export const SearchInput = styled(
  ({
    className,
    id,
    label,
    margin,
    onChange,
    onClear,
    onSubmit,
    placeholder,
    value = '',
  }: SearchInputProps) => {
    const [isClearBtnHidden, setIsClearBtnHidden] = useState(true)
    const [searchValue, setSearchValue] = useState<string>('')

    const onInputChange = (e: React.SyntheticEvent<HTMLInputElement>) => {
      const inputValue = e.currentTarget.value
      setIsClearBtnHidden(!inputValue.length)
      setSearchValue(inputValue)

      if (onChange) {
        onChange(inputValue)
      }
    }

    const onKeyDown = (e: React.KeyboardEvent) => {
      if (e.key === 'Enter') {
        onSubmit()
      }
    }

    const onClearClick = (e: React.SyntheticEvent) => {
      e.preventDefault()
      if (searchValue) {
        setSearchValue('')
        setIsClearBtnHidden(true)

        onClear()
      }
    }

    useEffect(() => {
      setSearchValue(value)

      if (!value) {
        setIsClearBtnHidden(true)
      }

      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value])

    return (
      <Box className={className} margin={margin}>
        <label htmlFor={id}>{label}</label>
        <span className="search-icon">
          <CloudflareImage src="/images/icon/search.svg" width={24} height={24} />
        </span>
        <input
          id={id}
          autoComplete="off"
          type="search"
          value={searchValue}
          onChange={onInputChange}
          onKeyDown={onKeyDown}
          placeholder={placeholder}
        />
        <a href="#" onClick={onClearClick} hidden={isClearBtnHidden}>
          <span className="remove-icon">
            <CloudflareImage src="/images/icon/close.svg" width={16} height={16} />
          </span>
        </a>
      </Box>
    )
  }
)({
  '.remove-icon': {
    position: 'absolute',
    right: '14px',
    top: '1.3em',
    width: '1em',
  },
  '.search-icon': {
    left: '14px',
    position: 'absolute',
    top: '1em',
    width: '1.5em',
  },

  input: {
    ...inputStyle,
    top: 0,
  },

  label: {
    ...labelStyle,
    fontWeight: 200,
    left: '51px',
  },
  position: 'relative',
})

export default SearchInput
